import WX_API from '@/utils/wx_api'

export default {
    data () {
        return {
            show_public_dlg: false
        }
    },
    computed: {
        apply_content () {
            if (!this.customer_service_info) {
                return ''
            }
            const { wx_username, wx_nickname } = this.customer_service_info
            return `请将需要更新的楼盘最新动态提供给您专属客服【${wx_username}（${wx_nickname}）】，可以加积分哦`
        }
    },
    methods: {
        publish (e) {
            if (this.building_event_author) {
                const { building_id } = this.$route.query
                wx.navigateTo({
                    url: `/pages/building/event/add/main?building_id=${building_id}`
                })
            } else {
                this.togglePublishDlg()
            }
        },
        togglePublishDlg () {
            this.show_public_dlg = !this.show_public_dlg
        },
        copyWexin () {
            WX_API.setClipboardData(this.customer_service_info.wx_username)
        }
    }
}
